import type React from 'react';

import type { IconProps } from 'types/icon';

const Trash: React.FC<IconProps> = ({
  size = '16',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M3.125 6.24998H5.20833M5.20833 6.24998H21.875M5.20833 6.24998V20.8333C5.20833 21.3858 5.42783 21.9158 5.81853 22.3065C6.20923 22.6972 6.73913 22.9166 7.29167 22.9166H17.7083C18.2609 22.9166 18.7908 22.6972 19.1815 22.3065C19.5722 21.9158 19.7917 21.3858 19.7917 20.8333V6.24998M8.33333 6.24998V4.16665C8.33333 3.61411 8.55283 3.08421 8.94353 2.69351C9.33423 2.30281 9.86413 2.08331 10.4167 2.08331H14.5833C15.1359 2.08331 15.6658 2.30281 16.0565 2.69351C16.4472 3.08421 16.6667 3.61411 16.6667 4.16665V6.24998M10.4167 11.4583V17.7083M14.5833 11.4583V17.7083"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Trash;
